export const name = "REPLACE";
export const summary = `Replaces all occurrences of a pattern with another pattern in a \`STRING\` or \`BYTES\` value.`;
export const reference = `
## REPLACE

Replaces all occurrences of a pattern with another pattern in a \`STRING\` or \`BYTES\` value.

\`\`\`
REPLACE(original_value, from_pattern, to_pattern)
\`\`\`

### Description

Replaces all occurrences of \`from_pattern\` with \`to_pattern\` in\`original_value\`. If \`from_pattern\` is empty, no replacement is made.

This function supports specifying collation.


### Return type

\`STRING\` or \`BYTES\`


### Examples



\`\`\`
WITH desserts AS
  (SELECT 'apple pie' as dessert
  UNION ALL
  SELECT 'blackberry pie' as dessert
  UNION ALL
  SELECT 'cherry pie' as dessert)

SELECT
  REPLACE (dessert, 'pie', 'cobbler') as example
FROM desserts;

/*--------------------*
 | example |
 +--------------------+
 | apple cobbler |
 | blackberry cobbler |
 | cherry cobbler |
 *--------------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/string_functions
`;
